<template>
<div>
  <div class="rich-input">
    <input class="rich-input-field"
      :placeholder="placeholder"
      :value="inputValue"
      type="text"
      :maxlength="maxlength"
      @input="changeHandle($event.target)"
      @blur="blurHandle">
  </div>
</div>
</template>
<script>
export default {
  name: 'CPFInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    numType: {
      type: String,
      default: 'CPF'
    },
    placeholder: {
      type: String
    }
  },
  inject: ['rootForm'],
  data () {
    return {
      inputValue: this.value,
      prop: 'CPFInput'
    }
  },
  mounted () {
  },
  computed: {
    formatFunc () {
      let func = this.formatCPF
      switch (this.numType) {
        case 'CPF':
          func = this.formatCPF
          break
        case 'CNPJ':
          func = this.formatCNPJ
          break
        default:
          break
      }
      return func
    },
    maxlength () {
      return this.numType === 'CNPJ' ? 18 : 14
    }
  },
  methods: {
    changeHandle (target) {
      let value = target.value.trim().replace(/[^0-9\.\-\/]/g, '')
      let inputValue = value
      let numberStr = value.replace(/\.|\-|\//g, '')
      let newStr = value
      if (value.length >= this.inputValue.length) {
        newStr = this.formatFunc(numberStr)
      }
      target.value = newStr
      this.inputValue = newStr
      this.$emit('input', this.inputValue)
    },
    blurHandle (e) {
      this.rootForm.$emit('input-blur', { e, prop: this.prop })
    },
    formatCPF (str) {
      return str.replace(/^(\d{3})(\d{0,3})(\d{0,3})(\d{0,2})/, (matchStr, first, second, thrid, four, five) => {
        let newStr = ''
        newStr = first
        if (second) {
          newStr = newStr + '.' + second
        }
        if (thrid) {
          newStr = newStr + '.' + thrid
        }
        if (four) {
          newStr = newStr + '-' + four
        }
        return newStr
      })
    },
    formatCNPJ (str) {
      return str.replace(/^(\d{2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/, (matchStr, first, second, thrid, four, five) => {
        let newStr = ''
         newStr = first
        if (second) {
          newStr = newStr + '.' + second
        }
        if (thrid) {
          newStr = newStr + '.' + thrid
        }
        if (four) {
          newStr = newStr + '/' + four
        }
        if (five) {
          newStr = newStr + '-' + five
        }
        return newStr
      })
    }
  }
}
</script>
<style lang="stylus" scoped>

</style>